<app-loader [loaded]="loaded" [progress]="loadingProgress"></app-loader>
<app-nav></app-nav>
<div class="demo-info">
  <p><b>Geometry Demo</b></p>
  <p>Try opening the console and typing:</p>
  <code id="geometryCode">
    {{
      'var parameters = { ModuleName: "Module 3", Xdim: 10., Ydim: 1., Zdim: 45, NumPhiEl: 64, NumZEl: 10, Radius: 105, MinZ: -250, MaxZ: 250, TiltAngle: 0.3, PhiOffset: 0.0, Colour: 0xffff00, EdgeColour: 0x449458 };\
    window.EventDisplay.buildGeometryFromParameters(parameters);'
    }}
  </code>
  <p class="copy-code" (click)="copyCode()"><b>Copy</b></p>
</div>

<div id="eventDisplay"></div>
